import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import type { ApplyInvitesProfile } from '@/types';
import { InviteNotFound } from '../components/InviteNotFound';
import { ProfileMultiStep } from '../components/ProfileMultiStep';

function firstName(fullName: string): string {
  return fullName.trim().split(/\s+/)[0]?.toLowerCase() || 'hacker';
}

// app/(public)/${eventSlug}/invite/[handle]/profile/page.tsx + invitee-profile-form.tsx.
export default function Profile({
  segment,
  ownerFullName,
  storageKey,
  initial,
  notFoundReason,
  linkedinCheckUrl,
  photoStep,
}: ApplyInvitesProfile) {
  const { eventSlug } = useApplyEdition();
  if (notFoundReason || !initial) {
    return (
      <>
        <InviteNotFound reason={notFoundReason ?? 'invalid'} />
      </>
    );
  }

  return (
    <>
      <ProfileMultiStep
        ownerName={ownerFullName}
        ownerFirstName={firstName(ownerFullName)}
        initial={initial}
        storageKey={storageKey}
        submitUrl={`/${eventSlug}/invite/${segment}/profile`}
        submitMethod="post"
        submitLabel="Sumarme al equipo"
        linkedinCheckUrl={linkedinCheckUrl}
        photoStep={photoStep}
      />
    </>
  );
}
